import Vue from "vue";
import App from "./App.vue";
import VueScrollTo from "vue-scrollto";

export default function init() {
  const element = document.getElementById("faqList");

  if (element) {
    Vue.config.productionTip = false;
    Vue.use(VueScrollTo, {
      container: "body",
      duration: 500,
      easing: "ease",
      offset: 0,
      force: true,
      cancelable: true,
      onStart: false,
      onDone: false,
      onCancel: false,
      x: false,
      y: true
    });

    new Vue({
      render: createElement => {
        const context = {
          props: { ...element.dataset }
        };
        return createElement(App, context);
      }
    }).$mount("#faqList");
  }
}
